import { GameScreensConfiguration } from '@luckycart/xpn-types';

// Use generator to avoid reference issues on same object
export function getDefaultConfigurations (): GameScreensConfiguration {
  return {
    alreadyPlayed: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '',
      },
    },
    error: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '<span style="font-size:6vw;">Une erreur est survenue.</span>',
      },
    },
    expired: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '<span style="font-size:6vw;">Votre jeu a expiré.</span>',
      },
    },
    game: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '',
      },
      plugin: {
        plugins: {
          armedBandit: {
            background: {
              color: '#01803F',
            },
            loseImg: {
              imageUrl: 'https://statics.luckycart.com/design/intermarche/2gdhwq/images/game-page-background_1647522996846.jpg',
            },
            otherImg: {
              imageUrl: 'https://statics.luckycart.com/design/intermarche/2gdhwq/images/game-page-background_1647522996846.jpg',
            },
            winImg: {
              imageUrl: 'https://statics.luckycart.com/design/intermarche/2gdhwq/images/game-page-background_1647522993998.jpg',
            },
          },
          scratch: {
            background: {
              color: 'white',
            },
            stars: {
              color: 'white',
            },
          },
          wheel: {
            lose: {
              color: 'white',
              imageUrl: null,
            },
            win: {
              color: 'white',
              imageUrl: null,
            },
          },
          video: {
            win: { mp4: '' },
            lose: { mp4: '' },
            landing: { mp4: '' },
          },
        },
        type: 'wheel',
      },
    },
    home: {
      acceptTextBox: {
        html: '',
      },
      background: {
        color: 'white',
        imageUrl: null,
      },
      ctaButton: {
        background: {
          color: 'white',
          imageUrl: null,
        },
        html: '',
      },
      mainTextBox: {
        html: '',
      },
    },
    lost: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '',
      },
    },
    next: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      ctaButton: {
        background: {
          color: 'white',
          imageUrl: null,
        },
        html: '',
      },
      mainTextBox: {
        html: '',
      },
    },
    won: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '',
      },
    },
    unavailable: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '<span style="font-size:6vw;">Ooops! Votre jeu n est plus disponible.</span>',
      },
    },
  };
}
